// @ts-nocheck
import { useEffect, useState } from 'react';
import { Source, Layer } from 'react-map-gl/maplibre';
import { MapLibreLayerSpecification } from '../../types';

interface LayersProps {
  mapLibreLayers: MapLibreLayerSpecification[];
  visibleLayers: Set<string>;
}

const Layers: React.FC<LayersProps> = ({ mapLibreLayers, visibleLayers }) => {
  const [loadedSources, setLoadedSources] = useState<Record<string, boolean>>({});

  // Handle source loading errors using event listeners
  useEffect(() => {
    const handleSourceError = (layerId: string) => {
      console.warn(`Failed to load source for layer ${layerId}`);
      setLoadedSources(prev => ({
        ...prev,
        [layerId]: false
      }));
    };

    // Add error listeners for each source
    mapLibreLayers.forEach(layer => {
      const map = (document.querySelector('.maplibregl-map') as any)?.map;
      if (map) {
        map.on(`error`, (e: any) => {
          if (e.source && e.source.id === layer.id) {
            handleSourceError(layer.id);
          }
        });
      }
    });

    // Cleanup listeners on unmount
    return () => {
      const map = (document.querySelector('.maplibregl-map') as any)?.map;
      if (map) {
        mapLibreLayers.forEach(layer => {
          map.off('error');
        });
      }
    };
  }, [mapLibreLayers]);

  // The transformToMapLibreLayer function in useMapLibreLayers.ts 
  // already converts Fulcrum layers to GeoJSON layers,
  // so by the time we get here, all layer types will be
  // properly processed as GeoJSON or raster.

  return (
    <>
      {mapLibreLayers
        .filter((layer) => layer.source.type === "geojson")
        .map((layer) => (
          <Source 
            key={layer.id}
            type="geojson" 
            data={layer.source.data as string}
          >
            {loadedSources[layer.id] !== false && (
              <Layer
                {...layer}
                id={layer.id}
                layout={{
                  ...layer.layout,
                  visibility: visibleLayers.has(layer.id) ? "visible" : "none",
                }}
              />
            )}
          </Source>
        ))}
      {mapLibreLayers
        .filter((layer) => layer.source.type === "raster")
        .map((layer) => (
          <Source
            key={layer.id}
            type="raster"
            tiles={layer.source.tiles}
            tileSize={layer.source.tileSize}
          >
            {loadedSources[layer.id] !== false && (
              <Layer
                {...layer}
                id={layer.id}
                layout={{
                  ...layer.layout,
                  visibility: visibleLayers.has(layer.id) ? "visible" : "none",
                }}
              />
            )}
          </Source>
        ))}
    </>
  );
};

export default Layers;
